<template>
  <v-app>
    <v-app-bar
      color="primary"
      dense
      app
      absolute
      class="mb-2 pb-2"
    >
      <div class="d-flex align-center">
        <router-link to="/">{{text.appBarText}}</router-link>
      </div>  
      <v-spacer></v-spacer>
        <v-btn class="m6" dark fab bottom color="green" x-small :href="`https://wa.me/?text=Hei%20-%20katso%20kaupungin%20lounaat:%20${text.urlLink}/?utm_source=whatsapp%26utm_medium=share`" target="_blank">
          <v-icon>mdi-whatsapp</v-icon>
        </v-btn>
        <v-btn class="m6" dark fab bottom color="tertiary" x-small :href="`mailto:?subject=Katso%20Lounaat&amp;body=Hei%20-%20katso%20kaupungin%20lounaat:%20${text.urlLink}/?utm_source=email%26utm_medium=share`" target="_blank">
          <v-icon>mdi-email</v-icon>
        </v-btn>
    
    </v-app-bar>
    
    
    <v-main>  
      <router-view v-bind:text="text" />
    </v-main>

    <Footer
    v-bind:copyRigth="text.copyRigth"
    v-bind:bottomNote="text.bottomNote"
    v-bind:contactEmail="text.contactEmail"
    />

  </v-app>
</template>

<script>
import Footer from "./components/footer.vue";
export default {
    name: 'App',
    components: { Footer },
    data() {
        return {
            text: '',
        }
    },
    methods: {
        getData() {
            let path = "/text.json";
            fetch(path)
            .then(res => res.json())
            .then((out) => {
               this.text = out;
            })
            .catch(err => { throw err });
        }
    },
    mounted() {
        this.getData();
    }
    
}
</script>



<style scoped>
.v-application a {
  color: white;
  text-decoration: none;
}
.m6 {
  margin: 6px;
}

</style>>